import type { TextContent, CommonText } from '../types/textContent';

export type { TextContent };

// List of available pages
const publicPages = ['index', 'omsjukdomen', 'omoss', 'kontakt', 'knowledge', 'berattelser']; // Added 'berattelser'

export async function loadTextContent(pageName: string): Promise<TextContent> {
  console.log('loadTextContent called with:', pageName);
  try {
    // For public content, use fetch
    if (publicPages.includes(pageName)) {
      let fetchPath = `/data/text/pages/${pageName}.json`;
      if (pageName === 'berattelser') {
        fetchPath = `/data/text/berattelser.json`; // Correct path for the articles list
      }
      const response = await fetch(fetchPath);
      if (!response.ok) {
        throw new Error(`Failed to fetch content: ${response.statusText}`);
      }
      const content = await response.json();
      console.log(`Loaded ${pageName} content:`, content);
      return content as TextContent;
    }

    throw new Error(`No content found for page: ${pageName}`);
  } catch (error) {
    console.error(`Error loading text content for ${pageName}:`, error);
    throw error;
  }
}

export function getTextFromPath(obj: any, path: string): string {
  return path.split('.').reduce((acc, part) => acc?.[part], obj) || path;
}
